import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const year = 2026;
  return (
    <footer className="mt-20 w-full bg-secondary-800 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-2xl text-background-50">看料99</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              看料99 是一个专注独家爆料与首发资源的资讯门户，每日更新第一手消息，覆盖娱乐、社会、职场与生活话题，
              以时间线还原事件脉络，让你点开即看。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-700 text-background-100">
                <i className="ri-mail-line" aria-hidden="true"></i>
              </span>
              <a
                href="mailto:hello@kanliao99.com"
                className="text-sm text-background-200 transition-colors hover:text-background-50"
              >
                hello@kanliao99.com
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">内容分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 transition-colors hover:text-background-50">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-background-300 transition-colors hover:text-background-50">
                  全部分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-300 transition-colors hover:text-background-50">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {year} 看料99 · 专注独家爆料与首发资源
          </p>
          <p className="text-xs text-background-400">
            站内内容为行业观察与资讯整理，不构成任何事实认定或建议。
          </p>
        </div>
      </div>
    </footer>
  );
}